<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Stream Daily Report</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>From Date</u></label>
        <input type="date" [(ngModel)]="filterable.fromDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>To Date</u></label>
        <input type="date" [(ngModel)]="filterable.toDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by ShortCode</u></label>
        <ng-select [items]="shortCodeFilterList" placeholder="Select short code" [(ngModel)]="filterable.shortCode" class="form-control" (ngModelChange)="changeShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Keyword</u></label>
        <select [(ngModel)]="filterable.keyword" class="form-control" placeholder="Keyword" (ngModelChange)="changeKeyword($event)">
          <option *ngFor="let keyword of keywordList" [ngValue]="keyword">{{keyword}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator">
          <option *ngFor="let operator of operatorList" [ngValue]="operator">{{operator}}</option>
        </select>
      </div>
    </div>

    <!-- <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div> -->
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Tabs: {{totalItems}}
  </div>
  <div class="col-2 ml-auto text-right align-self-end">
    <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
    <button class="btn btn-success btn-sm mr-2" (click)="export()" *ngIf="!exporting">Export</button>
    <button class="btn btn-success btn-sm mr-2 d-none" id="download" (click)="openModal(viewDownloadUrl)">Open</button>
    <button class="btn btn-success btn-sm mr-2" *ngIf="exporting" disabled>Exporting</button>
  </div>
  <!-- <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <label for=""><u>Go to page </u> <span class="small">(Max: {{maxPageSize}})</span></label>
    <input type="number" class="form-control form-control-sm" placeholder="Page" [(ngModel)]="goToPage" max="{{maxPageSize}}">
  </div>
  <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <button (click)="setPage(goToPage)" class="btn btn-sm btn-outline-primary">Go</button>
  </div> -->
</div>
<!-- <div class="table-responsive"> -->
<div *ngIf="loaded">
  <table id="reportList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
    <thead>
      <tr>
        <th>Day</th>
        <th>Total</th>
        <th>Withhold</th>
        <th>PostBack Success</th>
        <th>Other</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="loading">
        <td colspan="12">
          <div class="loader">Loading...</div>
        </td>
      </tr>
      <tr *ngIf="emptyResult">
        <td colspan="12">
          <div class="alert alert-warning">Empty Result...</div>
        </td>
      </tr>
      <tr *ngFor="let report of streamReports">
        <td nowrap>{{report.day}}</td>
        <td >{{report.total}}</td>
        <td>{{report.withhold}}</td>
        <td>{{report.success}}</td>
        <td>{{report.other}}</td>
      </tr>
    </tbody>
    <tfoot>
    </tfoot>
  </table>
</div>

<ng-template #viewDownloadUrl let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="downloadUrl-header">Download URL</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to download:
        <a href={{downloadUrl}} target="_blank">
          {{downloadUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
